/**
 * Global translation function from js-localization
 * @param {string} key - Translation key
 * @param {Object} [replacements] - Optional replacements
 * @param {string} [forceLocale] - Optional locale
 * @returns {string} Translated string
 */
export const trans = window.trans;

/**
 * Global pluralized translation function
 * @param {string} key - Translation key
 * @param {number} count - Count for pluralization
 * @param {Object} [replacements] - Optional replacements
 * @returns {string} Translated string
 */
export const transChoice = window.transChoice;
